import { Button, Flex, Heading } from '@chakra-ui/react';
import { mdiPlus } from '@mdi/js';
import EmptyState from 'features/common/components/EmptyState';
import { PortalIcon } from 'features/common/components/PortalIcon';
import { history } from 'features/common/history/history';
import { useFilteredContextswithResources } from 'features/context-ids/hooks';
import { getAddScopedContextRoute } from 'features/context-ids/routes';
import { useMemo } from 'react';
import { useParams } from 'react-router';
import {
  DataTable,
  DataTableSortingRule,
} from '../../../../../common/components/DataTable';
import { SitecoreContextResourceType } from '../../../../types/types';
import { getTableOptions } from './helpers';

const onClickAdd = (sitecoreContextId: string) =>
  history.push({
    pathname: getAddScopedContextRoute(sitecoreContextId),
    search: history.location.search,
  });

export const FilteredContextsTable = ({
  resources = [],
}: {
  resources?: SitecoreContextResourceType[];
}) => {
  const { sitecoreContextId } = useParams<{ sitecoreContextId: string }>();
  const initialSortBy = useMemo<DataTableSortingRule[]>(
    () => [{ id: 'id', desc: false }],
    [],
  );

  const { filteredContextsWithResources, isLoading } =
    useFilteredContextswithResources({ resources, sitecoreContextId });
  const options = useMemo(() => getTableOptions(), []);

  return (
    <Flex direction='column' gap={6}>
      <Flex justifyContent='space-between'>
        <Heading size='md' data-testid='scoped-context-id-header'>
          Scoped Context IDs
        </Heading>
        <Button
          variant='outline'
          onClick={() => onClickAdd(sitecoreContextId)}
          leftIcon={<PortalIcon path={mdiPlus} />}
          data-testid='create-scoped-context-id'
          data-behavior-analytics-id='Create scoped Context ID button - Context IDs page'
        >
          Create scoped Context ID
        </Button>
      </Flex>
      {filteredContextsWithResources.length || isLoading ? (
        <DataTable
          columns={options.columns}
          rowActions={options.rowActions}
          onChange={() => {
            /* autoSort handles sorting internally */
          }}
          isLoading={isLoading}
          data={filteredContextsWithResources}
          sortBy={initialSortBy}
          page={1}
          pagination='hidden'
          data-behavior-analytics-feature='scoped context ids table'
        />
      ) : (
        <Flex my={5}>
          <EmptyState
            text='No scoped Context IDs'
            description='Add a scoped Context ID'
            boxSize='20'
            dataTestId='no-scoped-context-container'
          />
        </Flex>
      )}
    </Flex>
  );
};
